export default {"src":"/_next/static/media/profile-difficulties.217a73c2.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};